import { Listing } from '@truckdown/locations';
import { defineComponent, ref, Ref } from 'vue';

interface ILinkData {
    id: string,
    accountId: string,
    nameForUrl: string,
    showRequestService: boolean,
    showEditLinks: boolean,
    showReportUpdate: boolean,
    showAdminViewLinks: boolean,
    showRemoveLink: boolean,
    showUpgradeLink: boolean,
    showViewServiceLink: boolean,
    showDetailsLink: boolean,
    showWebsiteLink: boolean,
    showPhoneNumbersLink: boolean,
    isFleet: boolean,
    isAuthenticated: boolean,
    editHoursUrl?: string,
    detailsLink: string,
    editUrl?: string,
    notesLabel: string,
    preferredLabel: string
    disableActions: boolean,
    disableMap: boolean,
    hideAllLinks: boolean
}

interface IData {
    showRequestServiceButton: Ref<boolean>,
    showMenu: Ref<boolean>
}

const getData = function () {
    return {
        showRequestServiceButton: ref<boolean>(false),
        showMenu: ref<boolean>(false)
    } as IData;
}

const getMethods = function (ctx: any, data: IData) {
    return {
        toggleMenu: function (ev: Event) {
            data.showMenu.value = !data.showMenu.value;
        },
        closeMenu: function (ev: Event) {
            data.showMenu.value = false;
        },
        clickShowNumbers: function (ev: Event) {
            ctx.emit('show-numbers');
        },
        clickViewServices: function (ev: Event) {
            ctx.emit('view-services');
        },
        clickViewWebsite: function (ev: Event) {
            ctx.emit('view-website');
        },
        showOnMap: function (ev: Event) {
            ctx.emit('show-on-map');
        },
        clickReportUpdate: function (ev: Event) {
            ctx.emit('report-update');
        },
        clickRemoveListing: function (ev: Event) {
            ctx.emit('remove-listing');
        },
        clickUpgradeListing: function (ev: Event) {
            ctx.emit('upgrade-listing');
        },
        clickForwardListing: function (ev: Event) {
            ctx.emit('forward-listing');
        },
        clickRateService: function (ev: Event) {
            ctx.emit('rate-service');
        },
        clickAddNote: function (ev: Event) {
            ctx.emit('add-note');
        },
        clickAddFavorite: function (ev: Event) {
            ctx.emit('favorite');
        },
        clickAddDnu: function (ev: Event) {
            ctx.emit('avoid');
        },
        clickRequestService: function () {
            data.showRequestServiceButton.value = true;
        },
        closeRequestService: function () {
            data.showRequestServiceButton.value = false;
        }
    };
}

export default defineComponent({
    props: {
        display: String,
        listing: {
            type: Object as () => Listing,
            required: true
        },
        linkData: {
            type: Object as () => ILinkData,
            required: true
        },
        showLinksOnly: Boolean
    },
    emits: [
        'report-update',
        'remove-listing',
        'upgrade-listing',
        'view-services',
        'view-website',
        'show-numbers',
        'favorite',
        'avoid',
        'add-note',
        'rate-service',
        'forward-listing',
        'show-on-map'
    ],
    setup: function (props, ctx) {
        let data = getData();
        let methods = getMethods(ctx, data);

        return {
            ...data,
            ...methods
        };
    }
});
